<template>
  <div>
    <Head :title="__(title)" />
    <div class="flex flex-col md:flex-row gap-3 mb-4 justify-between items-center ticket-filters">
      <search-input v-model="form.search" class="w-full max-w-md search" @reset="reset"></search-input>
      <div class="filter-add-new flex flex-col gap-3 md:flex-row items-center">
        <!-- <a
          v-if="user_access.asset.export"
          class="uppercase gap-[1px] text-sm px-3 py-2 flex items-center justify-center"
          href
        >
          <img class="w-6 h-6" src="/images/svg/export-csv.svg" alt="Export CSV" />
          <span>{{ __('Export') }}</span>
        </a>-->
        <!-- Start Date -->
        <text-input
          v-model="form.start_date"
          type="date"
          placeholder="Start Date"
          :label="__('Start Date')"
          @change="validateDateRange"
        />

        <!-- End Date -->
        <text-input
          v-model="form.end_date"
          type="date"
          placeholder="End Date"
          :label="__('End Date')"
          @change="validateDateRange"
        />

        <select
          v-model="form.limit"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        >
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>
    </div>

    <div class="flex flex-col gap-3 mb-4 md:flex-row w-full items-center ticket-filters">
      <div class="mr-2 w-full">{{ __('Filter Asset By') }}:</div>
      <!-- <select-input v-model="form.type_id" class="mr-2 w-full">
          <option :value="null">{{ __('Type') }}</option>
          <option v-for="s in types" :key="s.id" :value="s.id">{{ s.name }}</option>
      </select-input>-->
      <select-input-filter
        :placeholder="__('Type Asset')"
        :onInput="doFilter"
        @focus="doFilter"
        :items="types_asset"
        v-model="form.type_id"
        class="w-full"
      ></select-input-filter>
      <select-input v-model="form.category_id" class="mr-2 w-full">
        <option :value="null">{{ __('Category') }}</option>
        <option v-for="s in categories" :key="s.id" :value="s.id">{{ s.name }}</option>
      </select-input>
      <select-input v-model="form.brand_id" class="mr-2 w-full">
        <option :value="null">{{ __('Brand') }}</option>
        <option v-for="s in brands" :key="s.id" :value="s.id">{{ s.name }}</option>
      </select-input>
      <select-input v-model="form.type" class="mr-2 w-full">
        <option :value="null">{{ __('Type') }}</option>
        <option v-for="s in types" :key="s.value" :value="s.value">{{ s.label }}</option>
      </select-input>
      <Link class="btn-indigo" :href="this.route('history_asset')">
        <span>{{ __('Reset Filter') }}</span>
      </Link>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto relative">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="px-6 pt-6 pb-4">#{{ __('ID') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Reff Code') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Serial Number') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Type Asset') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Brand') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Category') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Type') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Customer') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Created By') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Date') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(history, index) in history_assets.data"
            :key="index"
            class="hover:bg-gray-100 focus-within:bg-gray-100"
          >
            <td
              class="border-t px-6 py-4 items-center focus:text-indigo-500"
            >{{ (history_assets.current_page - 1) * history_assets.per_page + index + 1 }}</td>
            <td
              class="border-t px-6 py-4 items-center focus:text-indigo-500"
            >{{ history.reff_code }}</td>
            <td
              class="border-t px-6 py-4 items-center focus:text-indigo-500"
            >{{ history.serial_number }}</td>
            <td
              class="border-t px-6 py-4 items-center focus:text-indigo-500"
            >{{ history.type_asset }}</td>
            <td class="border-t px-6 py-4 items-center focus:text-indigo-500">{{ history.brand }}</td>
            <td class="border-t px-6 py-4 items-center focus:text-indigo-500">{{ history.category }}</td>
            <!-- <td class="border-t px-6 py-4 items-center focus:text-indigo-500">{{ history.type }}</td> -->
            <td class="border-t px-6 py-4 items-center focus:text-indigo-500">
              <span
                v-if="history.type === 'in'"
                class="px-2 py-0.5 rounded-full text-white bg-green-500 font-bold text-xs"
              >In</span>
              <span
                v-else
                class="px-2 py-0.5 rounded-full text-white bg-red-500 font-bold text-xs"
              >Out</span>
            </td>
            <td class="border-t px-6 py-4 items-center focus:text-indigo-500">{{ history.customer }}</td>
            <td
              class="border-t px-6 py-4 items-center focus:text-indigo-500"
            >{{ history.created_by }}</td>
            <td
              class="border-t items-center px-6 py-4 focus:text-indigo-500"
            >{{ history.created_at}}</td>
          </tr>
          <tr v-if="history_assets && history_assets.data && history_assets.data.length === 0">
            <td class="border-t px-6 py-4 text-center" colspan="10">No data found.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination class="mt-6" :links="history_assets.links" />
  </div>
</template>


    <script>
import { Link, Head } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'
import SelectInput from '@/Shared/SelectInput'
import axios from 'axios'
import SelectInputFilter from '@/Shared/SelectInputFilter'
import moment from 'moment'
import TextInput from '@/Shared/TextInput'

const types = [
  {
    value: 'in',
    label: 'In',
  },
  {
    value: 'out',
    label: 'Out',
  },
]

export default {
  metaInfo: { title: 'History Asset' },
  components: {
    Icon,
    Link,
    Head,
    Pagination,
    SearchInput,
    SelectInput,
    SelectInputFilter,
    TextInput,
  },
  layout: Layout,
  props: {
    title: String,
    filters: Object,
    history_assets: Object,
    types_asset: Array,
    categories: Array,
    brands: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        limit: this.filters.limit ?? 10,
        category_id: this.filters.category_id ?? null,
        brand_id: this.filters.brand_id ?? null,
        type_id: this.filters.type_id ?? null,
        type: this.filters.type ?? null,
        start_date: this.filters.start_date ?? null,
        end_date: this.filters.end_date ?? null,
      },
      user_access: this.$page.props.auth.user.access,
      types: types,
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        // Only fetch data if at least one filter is filled
        if (this.form.search || this.form.category_id || this.form.brand_id || this.form.type_id || this.form.type || this.form.start_date || this.form.end_date) {
          this.$inertia.get(this.route('history_asset'), pickBy(this.form), { preserveState: true })
        }
      }, 150),
    },
  },

  methods: {
    validateDateRange() {
      const { start_date, end_date } = this.form
      if (start_date && end_date && new Date(end_date) < new Date(start_date)) {
        alert('End date cannot be earlier than start date.')
        this.form.end_date = '' // Clear invalid end date
      } else {
        this.dateError = ''
      }
    },
    doFilter(e) {
      axios.get(this.route('filter.type_asset', { search: e.target.value })).then((res) => {
        this.types.splice(0, this.types.length, ...res.data)
      })
    },
    closeAllDropdowns() {
      this.dropdownOpen = {}
    },
    reset() {
      this.form = mapValues(this.form, () => null)
      this.history_assets = [] // Clear the displayed data
    },
  },

  created() {
    this.user = this.$page.props.auth.user
    const user_access = this.user.access
    // console.log(user_access)
    this.moment = moment
  },
}
</script>
